export enum AccountType {
  CorporateUser,
  IndividualUser,
  EvaluationUser,
}
